module.exports = "/dist/68f2c9aa62fcbcd7b094bea0497dee73.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100italic.woff2
// module id = 111
// module chunks = 0